import './utils/kickstart';
import 'intersection-observer';
import { scaleLog } from 'd3-scale';
import debounce from 'lodash.debounce';

// Navbar
import './components/navbar';

// Translation
import { __ } from './utils/i18n';

// Data
import { dateParser } from './utils/d3-utils';
import { loadJsonScript } from './utils/load-json-script';

// Charts
import LineTimeseries from './components/LineTimeseries.svelte';
import { render as countyCurves } from './components/curves/countyCurves';
import CountyDoublingTimeTable from './components/curves/CountyDoublingTimeTable.svelte';

///////////////////MODAL/////////////////////////////////////

var modal = document.querySelector('.m-outer-container');
import * as focusTrap from 'focus-trap'; // ESM
var contentContainer = document.querySelector('.m-content-container');
const trap = focusTrap.createFocusTrap('.m-content-container', {
  onActivate: () => contentContainer.classList.add('is-active'),
  onDeactivate: () => contentContainer.classList.remove('is-active'),
  initialFocus: () => document.querySelector('.m-content-container'),
  escapeDeactivates: false,
});

trap.activate();

// REWRITE THIS TO TARGET MAIN INSTEAD
var body = document.querySelector('body');
var main = document.querySelector('main');
var modal = document.querySelector('.m-outer-container');
var continueButton = document.querySelector('#continue-to-page');
var agreementCheckbox = document.querySelector('#agreement-checkbox');
// screenreader text w/ modal description
var screenreaderText = document.querySelector('.screenreader-text');

function freezeBody() {
  body.style.overflow = 'hidden';
  main.setAttribute('aria-hidden', 'true');
}
function unfreezeBody() {
  body.style.overflow = 'auto';
  main.setAttribute('aria-hidden', 'false');
  trap.deactivate();
  // modal?.setAttribute('aria-hidden', 'true');
}

freezeBody();
// if checkbox is checked, make "Continue to page clickable"

function toggleCheckbox(e) {
  // if it's the return key, also make it a click
  if (e.which == 13) {
    e.target.click();
  }
  let cb = e.target;
  if (cb.checked) {
    continueButton.disabled = false;

    // unlock the continue button
  } else {
    continueButton.disabled = true;
  }
}

agreementCheckbox.addEventListener('click', toggleCheckbox);
agreementCheckbox.addEventListener('keypress', toggleCheckbox);

// turn off modal when you click continue button
continueButton.addEventListener('click', function () {
  // display none on container
  modal.style.display = 'none';
  // hide screenreader text modal description from screen readers by just display none and w/ aria-hidden just in case
  screenreaderText.style.display = 'none';
  screenreaderText.setAttribute('aria-hidden', 'true');
  // un-fix background
  unfreezeBody();
});

/////////end of modal/////////////

// Changelog
import Changelog from './components/Changelog.svelte';
new Changelog({
  target: document.getElementById('changelog-container'),
  props: loadJsonScript('changelog-data'),
});

// Import data
const statewideTimeSeriesData = loadJsonScript('statewide-timeseries-data').map(
  (d) => {
    d.date = dateParser(d.date);
    return d;
  }
);

// Boot charts
const casesCumTarget = document.getElementById('statewide-chart');
new LineTimeseries({
  target: casesCumTarget,
  props: {
    title: __('Cumulative cases'),
    data: statewideTimeSeriesData.filter(
      (d) => d.reported_and_probable_cases >= 10
    ),
    width: casesCumTarget.offsetWidth,
    margin: { top: 20, right: 80, bottom: 25, left: 70 },
    attrs: [
      {
        headline: __("Cumulative <span class='cases-blue'>cases</span>"),
        label: __('Logarithmic'),
        value: 'reported_and_probable_cases',
        color: '#3995b7',
        yScaleType: scaleLog,
        yMin: 10,
      },
      {
        headline: __("Cumulative <span class='cases-blue'>cases</span>"),
        label: __('Linear'),
        value: 'reported_and_probable_cases',
        color: '#3995b7',
      },
    ],
    sourceline: __('California Department of Public Health'),
  },
});

countyCurves();
window.addEventListener('resize', debounce(countyCurves, 300));

new CountyDoublingTimeTable({
  target: document.getElementById('county-doubling-time-table-container'),
  props: {
    data: loadJsonScript('counties-timeseries-data'),
    metadata: loadJsonScript('counties-metadata'),
  },
});
